module.exports = require("./../../_gen/starling/rendering/MeshEffect");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/MeshEffect.js
// module id = 214
// module chunks = 0